export default __webpack_public_path__ + "./fonts/notificaciones.3ce15484.svg";